<t4-header icon="glyphicon-stats"></t4-header>
<t4-periodPicker #period [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
<div class="row">
  <!--<div class="col-md-6">
      <t4-chart [diagramIds]="[['FL_TypeTurnOver', 'y-axis-0']]" title="{{'Turbo.Bookings.Dashboard.Turnover' | translate : 'Turnover' }}" type="bar" [fromDate]="fromDate" [toDate]="toDate" unit="week"></t4-chart>
  </div>-->
  <div class="col-md-3">
    <t4-kpi title="{{'Turbo.Fleet.Dashboard.TrailerCount' | translate : 'Trailer count' }}" type="numeric" service="RentalObject/KpiTrailerCount" [fromDate]="fromDate" [toDate]="toDate"></t4-kpi>
  </div>
  <div class="col-md-3">
    <t4-kpi title="{{'Turbo.Fleet.Dashboard.DisabledCount' | translate : 'Disabled count' }}" type="numeric" invert="true" service="RentalObject/KpiDisabledTrailers" [fromDate]="fromDate" [toDate]="toDate"></t4-kpi>
  </div>

  <div class="col-md-3" *ngIf="false">
    <t4-kpi title="{{'Turbo.Fleet.Dashboard.Availability' | translate : 'Availability' }}" label1="{{'Turbo.Fleet.Dashboard.Availability.lbl1' | translate : 'Available' }}" label2="{{'Turbo.Fleet.Dashboard.Availability.lbl2' | translate : 'Unavailable' }}" type="chart" service="RentalObject/KpiAvailability" [fromDate]="fromDate" [toDate]="toDate"></t4-kpi>
  </div>

  <div class="col-md-3">
    <t4-kpi kpiId="Availability" title="{{'Turbo.Fleet.Dashboard.Availability' | translate : 'Availability' }}" type="chart" service="RentalObject/KpiAvailability" [fromDate]="fromDate" [toDate]="toDate" label1="{{'Turbo.Fleet.Dashboard.Availability.lbl1' | translate : 'Available' }}" label2="{{'Turbo.Fleet.Dashboard.Availability.lbl2' | translate : 'Unavailable' }}"></t4-kpi>
  </div>

  <div class="col-md-3">
    <t4-kpi title="{{'Turbo.Fleet.Dashboard.ActiveIssues' | translate : 'Active issues' }}" type="numeric" invert="true" service="Service/KpiActiveIssues" [fromDate]="fromDate" [toDate]="toDate"></t4-kpi>
  </div>
  <div class="col-md-6" *ngIf="false">
    <t4-container title="{{'Turbo.Fleet.Dashboard.Activity' | translate : 'Activity' }}" [isLoading]="loading.activity">
      <canvas mdbChart #chartActivity="mdb-base-chart"
              type="line"
              [datasets]="activityData"
              [labels]="monthLabels"
              [colors]="chartColors"
              [options]="chartOptions"
              [legend]="true"></canvas>
    </t4-container>
  </div>

  <div class="col-12 mt-5">
    <mat-tab-group>
      <mat-tab label="{{'Turbo.Bookings.Dashboard.TurnoverPerType' | translate : 'Turnover per type' }}">
        <t4-fleet-chart [diagramIds]="[['BO_TurnoverPerTrailer']]" title="" type="bar" orientation="horizontal" [fromDate]="fromDate" [toDate]="toDate" unit="week"></t4-fleet-chart>
      </mat-tab>
      <mat-tab label="{{'Turbo.Bookings.Dashboard.ProfitPerType' | translate : 'Profit per type' }}">
        <t4-fleet-chart [diagramIds]="[['ProfitPerTrailer']]" title="" type="bar" orientation="horizontal" [fromDate]="fromDate" [toDate]="toDate" unit="week"></t4-fleet-chart>
      </mat-tab>
      <mat-tab label="{{'Turbo.Bookings.Dashboard.RentalsPerType' | translate : 'Rentals per type' }}">
        <t4-fleet-chart [diagramIds]="[['RentalsPerTrailer']]" title="" type="bar" orientation="horizontal" [fromDate]="fromDate" [toDate]="toDate" unit="week"></t4-fleet-chart>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
